/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Base_User_Form_Lastname_Label1Inputs */

const en_base_user_form_lastname_label1 = /** @type {(inputs: Base_User_Form_Lastname_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Name`)
};

const de_base_user_form_lastname_label1 = /** @type {(inputs: Base_User_Form_Lastname_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachname`)
};

/**
* | output |
* | --- |
* | "Last Name" |
*
* @param {Base_User_Form_Lastname_Label1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const base_user_form_lastname_label1 = /** @type {((inputs?: Base_User_Form_Lastname_Label1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Base_User_Form_Lastname_Label1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_base_user_form_lastname_label1(inputs)
	return en_base_user_form_lastname_label1(inputs)
});
export { base_user_form_lastname_label1 as "base_user_form_lastName_label" }